var map = {
	"./_settings.scss": 1295,
	"./base/_alert-boxes.scss": 1296,
	"./base/_badges.scss": 1297,
	"./base/_base.scss": 1298,
	"./base/_cw-footer.scss": 1299,
	"./base/_fonts.scss": 1300,
	"./base/_forms.scss": 1301,
	"./base/_grid.scss": 1302,
	"./base/_layout.scss": 1303,
	"./base/_lightbox.scss": 1304,
	"./base/_modal.scss": 1305,
	"./base/_nav-bar.scss": 1306,
	"./base/_normal_font.scss": 448,
	"./base/_offcanvas.scss": 1307,
	"./base/_pagination.scss": 1308,
	"./base/_panels.scss": 1309,
	"./base/_sharing.scss": 1310,
	"./base/_switches.scss": 1311,
	"./base/_tables.scss": 1312,
	"./base/_tooltips.scss": 1313,
	"./base/_type.scss": 1314,
	"./base/_video.scss": 1315,
	"./base/_visibility.scss": 1316,
	"./base/buttons/_all.scss": 1317,
	"./base/buttons/_mixins.scss": 1318,
	"./base/buttons/_sharing.scss": 1319,
	"./base/forms/_checkboxes.scss": 1320,
	"./base/forms/_input-combos.scss": 1321,
	"./base/forms/_non-text.scss": 1322,
	"./base/forms/_text-fields.scss": 1323,
	"./base/nav-bar/_base-with-links.scss": 1324,
	"./base/nav-bar/_base.scss": 1325,
	"./base/nav-bar/_fade.scss": 1326,
	"./base/nav-bar/_inverted.scss": 1327,
	"./base/nav-bar/_large-up.scss": 1328,
	"./pages/accounts.scss": 1329,
	"./pages/admin.scss": 1330,
	"./pages/admin/grants.scss": 1331,
	"./pages/admin/offline_donations.scss": 1332,
	"./pages/authorization.scss": 1333,
	"./pages/birthdays.scss": 1334,
	"./pages/campaigns.scss": 1335,
	"./pages/charityball.scss": 1336,
	"./pages/donations.scss": 1337,
	"./pages/donations/_donate-form.scss": 1338,
	"./pages/donations/_generic-right-side-donate.scss": 1339,
	"./pages/donations/_hidden-campaign.scss": 1340,
	"./pages/donations/_sponsor-recognition.scss": 1341,
	"./pages/donations/_thank-you.scss": 1342,
	"./pages/donations/components/_ach-popout-form.scss": 1343,
	"./pages/donations/components/_apple-pay-button.scss": 1344,
	"./pages/donations/components/_browser-fallback.scss": 1345,
	"./pages/donations/components/_donate-buttons.scss": 1346,
	"./pages/donations/components/_donate-by-check-modal.scss": 1347,
	"./pages/donations/components/_donation-form-inputs.scss": 1348,
	"./pages/donations/components/_gift_aid.scss": 1349,
	"./pages/donations/components/_iho.scss": 1350,
	"./pages/donations/components/_offscreen-donate-components.scss": 1351,
	"./pages/donations/components/_stripe-elements.scss": 1352,
	"./pages/donations/direct.scss": 1353,
	"./pages/donations/general.scss": 1354,
	"./pages/donations/gift-the-spring.scss": 1355,
	"./pages/donations/in-honor-of.scss": 1356,
	"./pages/donations/sponsor.scss": 1357,
	"./pages/donations/the-spring-new.scss": 1358,
	"./pages/donations/thespring.scss": 1359,
	"./pages/donations/user.scss": 1360,
	"./pages/edit_mailing_list_subscriber.scss": 1361,
	"./pages/exceptions.scss": 1362,
	"./pages/founders.scss": 1363,
	"./pages/mailing-list-subscribers.scss": 1364,
	"./pages/partners.scss": 1365,
	"./pages/premium_impact_profile.scss": 1366,
	"./pages/profile/bps_membership.scss": 1367,
	"./pages/profile/lifetime_impact.scss": 1368,
	"./pages/profile/my_projects.scss": 1369,
	"./pages/profile/shared.scss": 1370,
	"./pages/profile/spring_membership.scss": 1371,
	"./pages/profile/user_private.scss": 1372,
	"./pages/profile/user_public.scss": 1373,
	"./pages/projects/_country_icons.scss": 1374,
	"./pages/projects/projects.scss": 1375,
	"./pages/redeem-the-spring.scss": 1376,
	"./pages/search.scss": 1377,
	"./pages/static_pages/about.scss": 1378,
	"./pages/static_pages/brand_partnerships.scss": 1379,
	"./pages/static_pages/company_match.scss": 1380,
	"./pages/static_pages/company_match_iframe.scss": 1381,
	"./pages/static_pages/completed_projects.scss": 1382,
	"./pages/static_pages/css_docs.scss": 1383,
	"./pages/static_pages/education.scss": 1384,
	"./pages/static_pages/error.scss": 1385,
	"./pages/static_pages/financials.scss": 1386,
	"./pages/static_pages/fundraise.scss": 1387,
	"./pages/static_pages/gala_dashboard.scss": 1388,
	"./pages/static_pages/gift_guide.scss": 1389,
	"./pages/static_pages/home.scss": 1390,
	"./pages/static_pages/hundred_percent_model.scss": 1391,
	"./pages/static_pages/in_kind_donations.scss": 1392,
	"./pages/static_pages/internships.scss": 1393,
	"./pages/static_pages/jobs.scss": 1394,
	"./pages/static_pages/kids.scss": 1395,
	"./pages/static_pages/local_partners.scss": 1396,
	"./pages/static_pages/media.scss": 1397,
	"./pages/static_pages/mission.scss": 1398,
	"./pages/static_pages/our_approach.scss": 1399,
	"./pages/static_pages/our_projects.scss": 1400,
	"./pages/static_pages/our_work.scss": 1401,
	"./pages/static_pages/privacy.scss": 1402,
	"./pages/static_pages/scott_harrison_story.scss": 1403,
	"./pages/static_pages/scotts_story.scss": 1404,
	"./pages/static_pages/sensors.scss": 1405,
	"./pages/static_pages/staff.scss": 1406,
	"./pages/static_pages/the_pool.scss": 1407,
	"./pages/static_pages/volunteer.scss": 1408,
	"./pages/static_pages/water_crisis_learn.scss": 1409,
	"./pages/static_pages/whywater.scss": 1410,
	"./pages/stories.scss": 1411,
	"./pages/subscriptions.scss": 1412,
	"./pages/the_spring_series.scss": 1413,
	"./pages/thirst/thirst.scss": 1414,
	"./pages/uk/about.scss": 1415,
	"./pages/uk/partnerships.scss": 1416,
	"./pages/uk/privacy.scss": 1417,
	"./pages/uk/uk.scss": 1418,
	"./pages/unpledge.scss": 1419,
	"./pages/video_landing_page.scss": 1420,
	"./pages/wwd/community.scss": 1421,
	"./pages/wwd/discover.scss": 1422,
	"./pages/wwd/explore.scss": 1423,
	"./pages/wwd/profile.scss": 1424,
	"./pages/wwd/shared.scss": 1425,
	"./pages/wwd/welcome.scss": 1426,
	"./patterns/action-tiles.scss": 1427,
	"./patterns/avatar-initial.scss": 1428,
	"./patterns/cards.scss": 1429,
	"./patterns/cw-icon-spin.scss": 1430,
	"./patterns/dashed-elements.scss": 1431,
	"./patterns/full-bottom-bg.scss": 1432,
	"./patterns/image-fill.scss": 1433,
	"./patterns/module.scss": 1434,
	"./patterns/progress.scss": 1435,
	"./patterns/side-by-side.scss": 1436,
	"./patterns/tabs.scss": 1437,
	"./patterns/text-separator.scss": 1438,
	"./patterns/yellow-underlined.scss": 1439,
	"./react-components/email-capture-modal.scss": 1440,
	"./react-components/journey-player.scss": 1441,
	"./react-components/mailing-list-intercept-modal.scss": 1442,
	"./react-components/map-spike.scss": 1443,
	"./react-components/people-served-input.scss": 1444,
	"./settings/_colors.scss": 1445,
	"./settings/_general.scss": 1446,
	"./settings/_media-queries.scss": 1447,
	"./settings/_mixins.scss": 1448,
	"./settings/_type.scss": 1449,
	"./shared/acts-as-user.scss": 1450,
	"./shared/breadcrumbs.scss": 1451,
	"./shared/clipboard-button.scss": 1452,
	"./shared/cookie_banner.scss": 1453,
	"./shared/datepicker.scss": 1454,
	"./shared/geosuggest.scss": 1455,
	"./shared/grecaptcha.scss": 1456,
	"./shared/hide-donate-links.scss": 1457,
	"./shared/intl-tel-input.scss": 1458,
	"./shared/mailing-list-form.scss": 1459,
	"./shared/mailing-list-sign-up-button.scss": 1460,
	"./shared/parsley.scss": 1461,
	"./shared/percy.scss": 1462,
	"./shared/public_campaign_card_details.scss": 1463,
	"./shared/simple-form.scss": 1464,
	"./shared/sly-quiz.scss": 1465,
	"./shared/spring_logo_svg.scss": 1466,
	"./shared/spring_mark_svg.scss": 1467,
	"./shared/video-box-container.scss": 1468,
	"./tailwinds.scss": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1294;